import produce from 'immer';
import { DeviceResponse, DeviceStatus } from 'api/Responses/DeviceResponses';
import { DeviceAction } from './deviceActions';

export const initialDevice: DeviceResponse = {
  id: '',
  user: '',
  owner_email: '',
  status: DeviceStatus.DRAFT,
  image: '',
  inspection_manual: undefined,
  description: '',
  cannulated: false,
  comments: [],
  num_parts: '1',
  disassembly_info: null,
  inspection_text: '',
  test_metadata: null,
  language_metadata: null,
  prone_to_debris: true,
};

const deviceReducer = produce((device: DeviceResponse, action: DeviceAction) => {
  switch (action.type) {
    case 'INIT':
      // Set debris inspection and prone for debris to true by default, if it hasn't been set yet
      action.payload = {
        ...action.payload,
        prone_to_debris: action.payload.prone_to_debris !== undefined ? action.payload.prone_to_debris : true,
        test_metadata: {
          ...action.payload.test_metadata,
          debris_test:
            action.payload.test_metadata?.debris_test !== undefined ? action.payload.test_metadata?.debris_test : true,
        },
      };

      Object.assign(device, action.payload);
      break;
    case 'ID':
      device.id = action.payload;
      break;
    case 'DESCRIPTION':
      // Duplicate data to appeal to SAVI-Mobile's legacy requirements
      device.description = action.payload;

      device.language_metadata = {
        ...device.language_metadata,
        description_english: action.payload || null,
      };

      break;
    case 'JAPANESE_DESCRIPTION':
      device.language_metadata = {
        ...device.language_metadata,
        description_japanese: action.payload || null,
      };

      break;
    case 'ADDITIONAL_INSPECTION':
      // Duplicate data to appeal to SAVI-Mobile's legacy requirements
      device.inspection_text = action.payload || null;

      device.test_metadata = {
        ...device.test_metadata,
        additional_inspection_english: action.payload || null,
      };

      break;
    case 'JAPANESE_ADDITIONAL_INSPECTION':
      device.test_metadata = {
        ...device.test_metadata,
        additional_inspection_japanese: action.payload || null,
      };

      break;
    case 'INSPECTION_MANUAL_URL':
      device.language_metadata = {
        ...device.language_metadata,
        manual_english: action.payload,
      };
      break;
    case 'DEBRIS_INSPECTION':
      const debris_test = action.payload;
      device.test_metadata = { ...device.test_metadata, debris_test };

      break;
    case 'FUNCTION_TEST':
      const functional_test = action.payload;
      device.test_metadata = { ...device.test_metadata, functional_test };

      break;
    case 'TORQUE_TEST':
      const torque_test = action.payload;
      device.test_metadata = { ...device.test_metadata, torque_test };

      break;
    case 'PRONE_TO_DEBRIS':
      device.prone_to_debris = action.payload;
      break;
    case 'IMAGE':
      device.image = action.payload;
      break;
    case 'INSPECTION_MANUAL':
      device.inspection_manual = action.payload;
      break;
    case 'STATUS':
      device.status = action.payload;
      break;
    case 'CANNULATED':
      device.cannulated = action.payload;
      break;
    case 'NUM_PARTS':
      device.num_parts = action.payload;
      break;
  }
});

export default deviceReducer;
